/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "df7bbf6ff1c08da348ac5ddd62211f83c9c21eba";
